import { LoggerFactory } from 'nordic/logger';

const logger = LoggerFactory('social-profile-view:utils:localStorage');

const isLocalStorageUndefined = () => typeof localStorage === 'undefined';

const getLocalItem = (key: string, defaultValue?: any) => {
  if (isLocalStorageUndefined()) {
    return defaultValue;
  }

  try {
    const stored = localStorage.getItem(key);

    return stored ? JSON.parse(stored) : defaultValue;
  } catch (error: unknown) {
    logger.info(String(error));
    return defaultValue;
  }
};

const setLocalItem = (key: string, value: any) => {
  if (isLocalStorageUndefined()) {
    return;
  }

  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (error: unknown) {
    logger.info(String(error));
  }
};

const removeLocalItem = (key: string) => {
  if (isLocalStorageUndefined()) {
    return;
  }

  try {
    localStorage.removeItem(key);
  } catch (error: unknown) {
    logger.info(String(error));
  }
};

const removeLocalItems = (keys: Array<string>) => {
  if (isLocalStorageUndefined()) {
    return;
  }

  try {
    keys.forEach((key: string) => {
      localStorage.removeItem(key);
    });
  } catch (error: unknown) {
    logger.info(String(error));
  }
};

export {
  isLocalStorageUndefined,
  getLocalItem,
  setLocalItem,
  removeLocalItem,
  removeLocalItems,
};
